import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class PartnerService {
  static async getOrders(partnerId) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/partner_get_orders`, {
        method: 'POST',
        body: JSON.stringify({ p_partner_id: partnerId }),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching orders:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async getRevenue(partnerId, filters) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/partner_get_revenue`, {
        method: 'POST',
        body: JSON.stringify({ p_partner_id: partnerId, ...(filters || {}) }),
      });
      return { success: true, data: (Array.isArray(data) ? data[0] : data) || {}, error: null };
    } catch (error) {
      console.error('Error fetching revenue:', error);
      return { success: false, data: {}, error: error.message };
    }
  }
}

